module.exports = "<li class=\"nav-item\">\r\n  <a class=\"nav-link spk-tab\" [ngClass]=\"class\" id=\"{{name}}\" data-toggle=\"tab\" href=\"#{{name}}\" role=\"tab\" (click)=\"updateTab(name)\"\r\n    attr.aria-controls=\"{{name}}\">{{label || (name | stringSpacer)}}</a>\r\n</li>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tab/spk-tab.component.html
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tab/spk-tab.component.html
// module chunks = main